<template>
  <div>
	Cleared <br>
	<a href="/">Return </a>
  </div>
</template>

<script>

import envConfig from './env_config.js'
import * as easing from 'eases/bounce-in'
import axios from 'axios'
export default {
  name: 'Setup',
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted() {
  },
	created: function () {
		localStorage.removeItem('JWT');
		localStorage.removeItem('name');
		localStorage.removeItem('timer-history');
		localStorage.removeItem('timer-started');
		localStorage.removeItem('timer-ended');


  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style>
</style>





